export default __webpack_public_path__ + "static/media/logo.32c2b356.png";